import {
  commonUrl,
  getRequest,
  postRequest,
  ResponseDI,
} from "../../../base/services/urlService";
import {
  GetLessonsQueryParamsDI,
  LessonDI,
  SerializedLessonsQueryParamsDI,
} from "../types";

type ResponseLesson = Omit<LessonDI, "id"> & { Id: number };

export type GetLessonsResponseDI = {
  lessons: Array<ResponseLesson>;
  lessonsCount: number;
  unApprovedLessonsCount: number;
};

interface Params extends GetLessonsQueryParamsDI {
  [index: string]: any;
}

export const getLessons2 = async (params?: Params) => {
  const url = `${commonUrl}/api/lesson/getLessons`;
  if (params) {
    const response = await postRequest<Params, ResponseDI<GetLessonsResponseDI>>(url, params);
    return response.result;  // מחזירים את התוצאה כדי שתהיה לך גישה לשדות שציפית להם
  } else {
    const response = await getRequest<ResponseDI<GetLessonsResponseDI>>(url);
    return response.result;  // מחזירים את התוצאה כדי שתהיה לך גישה לשדות שציפית להם
  }
};


export const getLessons = async (params?: Params) => {
  let url;

  if (params) {
    var queryString: SerializedLessonsQueryParamsDI = new URLSearchParams();
    for (let i in params) {
      queryString.set(i, params[i]);
    }
    url = `${commonUrl}/api/lesson/getLessons?${queryString}`;
  } else {
    url = `${commonUrl}/api/lesson/getLessons`;
  }

  const { result } = await getRequest<ResponseDI<GetLessonsResponseDI>>(url);

  return result;
};
